import _ from 'lodash'

export const queryStrProcess = (searchCondition: {[name: string]: string}, fieldName: string[]): string => {
  const queryStr = _(searchCondition)
  .pick(fieldName)
  .pickBy(v => !_.isEmpty(v))
  .mapValues((v, k) => `${k}=${v}`)
  .map()
  .join('&')

  return queryStr
}